// extracted by mini-css-extract-plugin
module.exports = {"beforeHeading":"SectionOurPickedComments_beforeHeading__XLa1_","heading":"SectionOurPickedComments_heading__J2nOX","twoColumns":"SectionOurPickedComments_twoColumns__p8fu6"};